export default __webpack_public_path__ + "assets/img/avatar-7.2c9ec73.png";